module.exports = __webpack_public_path__ + "img/wallet_03_pundix.2c54c18e.png";